import { useEffect, useState } from 'react';
import Api from '../api';

export interface OfficeHistory {
  completedAtLocation: number;
  lastRating: number | null;
}

export function getOfficeHistoryCopy(history: OfficeHistory): string {
  if (history.completedAtLocation === 0) return 'This candidate has not previously worked at your office';
  if (history.lastRating == null || history.lastRating <= 0) {
    return "This candidate has worked at your office previously, but you didn't rate them";
  }
  return history.lastRating >= 3
    ? 'This candidate has worked at your office previously and you indicated you liked them.'
    : 'This candidate has worked at your office previously and you indicated you were not happy with them.';
}

export function useOfficeHistory(hygienistId?: number | null, locationId?: number | null): OfficeHistory | null {
  const [history, setHistory] = useState<OfficeHistory | null>(null);
  useEffect(() => {
    setHistory(null);
    if (!hygienistId || !locationId) return;
    let active = true;
    Api.getHygienistOfficeHistory(hygienistId, locationId)
      .then(result => { if (active) setHistory(result); })
      .catch(() => { if (active) setHistory(null); });
    return () => { active = false; };
  }, [hygienistId, locationId]);
  return history;
}
